var _path, _g, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1617",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 14,
    width: 16,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.4561H17.754V21.795H2V14.4561Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1617)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.877 15.9561C5.646 15.9561 3.5 16.6831 3.5 18.1151C3.5 19.5611 5.646 20.2951 9.877 20.2951C14.108 20.2951 16.254 19.5681 16.254 18.1371C16.254 16.6891 14.108 15.9561 9.877 15.9561ZM9.877 21.7951C7.929 21.7951 2 21.7951 2 18.1151C2 14.8351 6.495 14.4561 9.877 14.4561C11.825 14.4561 17.754 14.4561 17.754 18.1371C17.754 21.4161 13.259 21.7951 9.877 21.7951Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87709 3.5C7.77309 3.5 6.06009 5.213 6.06009 7.318C6.05609 8.337 6.44809 9.292 7.16309 10.013C7.87909 10.733 8.83309 11.132 9.84909 11.136L9.87709 11.886V11.136C11.9821 11.136 13.6951 9.423 13.6951 7.318C13.6951 5.213 11.9821 3.5 9.87709 3.5ZM9.87709 12.636H9.84609C8.42709 12.631 7.09709 12.074 6.10009 11.07C5.10209 10.065 4.55509 8.731 4.56009 7.315C4.56009 4.386 6.94509 2 9.87709 2C12.8101 2 15.1951 4.386 15.1951 7.318C15.1951 10.25 12.8101 12.636 9.87709 12.636Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2041 13.4297C18.7901 13.4297 18.4541 13.0937 18.4541 12.6797V8.6687C18.4541 8.2547 18.7901 7.9187 19.2041 7.9187C19.6181 7.9187 19.9541 8.2547 19.9541 8.6687V12.6797C19.9541 13.0937 19.6181 13.4297 19.2041 13.4297Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2502 11.4238H17.1602C16.7462 11.4238 16.4102 11.0878 16.4102 10.6738C16.4102 10.2598 16.7462 9.92383 17.1602 9.92383H21.2502C21.6642 9.92383 22.0002 10.2598 22.0002 10.6738C22.0002 11.0878 21.6642 11.4238 21.2502 11.4238Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/AddUser.17e4a2da1b497db399bbc80a986e3cf3.svg";
export { ForwardRef as ReactComponent };